import type { FaireProductEntity } from "../../entity_types/product";

export const p_58t39dga2a: FaireProductEntity = {
  token: "p_58t39dga2a",
  type: "product",
  name: "Toggi Fine European Wafers Dark Chocolate 1.75oz 24 ct Tray",
  brandToken: "b_et6a66kd2z",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3a22316266bac1709c6740f46c4f28299debe282bd67296980bb65c572209087.jpeg",
  galleryImageUrls: [],
  priceDollars: 55.42,
  description:
    "Experience moments of everyday indulgence with Toggi® Fine European Chocolate Wafers. Our light, crisp and delicious wafers are made from the highest quality, all-natural ingredients, then covered in the finest quality pure premium European milk chocolate. There’s simply nothing like Toggi® Wafers…The European Treat.™ Each 1.75oz wafer is crafted with high-quality ingredients and individually wrapped to maintain freshness. The 24 ct tray provides a convenient option for stocking up or sharing. Ideal for enjoying as a snack, dessert, or alongside your favorite beverage.",
  tags: [],
  msrpDollars: 110.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:29:33.256Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
